import React from 'react';
import { motion } from 'framer-motion';
import { ShoppingCart } from 'lucide-react';
interface CTAButtonProps {
  className?: string;
  variant?: 'scroll' | 'checkout';
}
export function CTAButton({
  className = '',
  variant = 'scroll'
}: CTAButtonProps) {
  if (variant === 'checkout') {
    return <motion.a href="https://tucentrovital.com/cart/48353851736164:1" target="_blank" rel="noopener noreferrer" whileHover={{
      scale: 1.02
    }} whileTap={{
      scale: 0.98
    }} className={`group relative inline-flex items-center justify-center gap-3 bg-brand-orange text-white px-8 py-4 rounded-full font-bold text-lg md:text-xl shadow-lg hover:bg-brand-orange-hover transition-colors duration-300 overflow-hidden no-underline ${className}`} onClick={() => {
      if (typeof window !== 'undefined' && window.fbq) {
        window.fbq('track', 'AddToCart');
      }
    }} data-id="element-13">
        <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black" data-id="element-14"></span>
        <span className="relative flex items-center gap-2" data-id="element-15">
          ¡Quiero mi Reset Metabólico Ahora!
          <ShoppingCart className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-16" />
        </span>
      </motion.a>;
  }
  return <motion.button whileHover={{
    scale: 1.02
  }} whileTap={{
    scale: 0.98
  }} className={`group relative inline-flex items-center justify-center gap-3 bg-brand-orange text-white px-8 py-4 rounded-full font-bold text-lg md:text-xl shadow-lg hover:bg-brand-orange-hover transition-colors duration-300 overflow-hidden ${className}`} onClick={() => {
    const offerSection = document.getElementById('offer-section');
    if (offerSection) {
      offerSection.scrollIntoView({
        behavior: 'smooth'
      });
    }
  }} data-id="element-17">
      <span className="absolute inset-0 w-full h-full -mt-1 rounded-lg opacity-30 bg-gradient-to-b from-transparent via-transparent to-black" data-id="element-18"></span>
      <span className="relative flex items-center gap-2" data-id="element-19">
        ¡Quiero mi Reset Metabólico Ahora!
        <ShoppingCart className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-20" />
      </span>
    </motion.button>;
}